import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';

@Component({
  selector: 'app-edit-event-name',
  templateUrl: './edit-event-name.component.html',
  styleUrls: ['./edit-event-name.component.scss']
})
export class EditEventNameComponent implements OnInit {
  formGroup: FormGroup;
  aviationEvent: AviationEvent;
  _originTitle: string;
  isBusy = false;

  constructor(private _matDialogRef: MatDialogRef<EditEventNameComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _aviationEventsService: AviationEventsService) {
    this.aviationEvent = data.aviationEvent;
    this._originTitle = this.aviationEvent.title; }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(null);
    });

    this.formGroup = new FormGroup({
      title: new FormControl(this.aviationEvent.title, [Validators.required, Validators.maxLength(256)])
    });
  }

  cancel () {
    this.aviationEvent.title = this._originTitle;
    this._matDialogRef.close(null);
  }

  async save () {
    if (this.aviationEvent.title) {
      this.aviationEvent.title = this.aviationEvent.title.trim();
    }
    try {
      this.isBusy = true;
      await this._aviationEventsService.updateAviationEvent(this.aviationEvent);
      this.isBusy = false;
      this._matDialogRef.close(true);
    } catch (e) {
      this.isBusy = false;
      this._matDialogRef.close(false);
    }
  }
}
